var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { GoodDamageComponent } from '../GoodDamageComponent';
import LengthInput from '@declaration/components/LengthInput.vue';
let WorkplanDescription = class WorkplanDescription extends GoodDamageComponent {
    get title() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.furniture.workplan.size');
    }
    get widthLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.furniture.workplan.width');
    }
    get heightLabel() {
        return this.$tc('claim.damage.real_estate.room_damage.form.question.good_damage.furniture.workplan.height');
    }
    get width() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : null;
    }
    set width(width) {
        this.updateGoodDamage({ width });
    }
    get height() {
        var _a, _b;
        return (_b = (_a = this.goodDamage) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : null;
    }
    set height(height) {
        this.updateGoodDamage({ height });
    }
};
WorkplanDescription = __decorate([
    Component({ components: { LengthInput } })
], WorkplanDescription);
export default WorkplanDescription;
